module.exports = __webpack_public_path__ + "img/bicycle-green.162f3aeb.svg";